import { TableHeadersType } from '../tableHeadersType';

export const DEPARTMENT_HEADER: TableHeadersType[] = [
  {
    "label": "Department Name",
    "value": "department_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Status",
    "value": "status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ACTION",
    "value": "Edit",
  },
]
